import React, { useContext } from 'react';
import { BookOpen, Tag } from 'lucide-react';
import HTMLContent from './HTMLContent';
import { ThemeContext } from "../context/ThemeProvider";

const ExplanationComponent = ({ explanation, topic, sub_domain }) => {
  const { theme } = useContext(ThemeContext);

  return (
    <div className="space-y-6 pt-6">
      {/* Explanation Section */}
      <div className="rounded-lg border shadow-sm"
      style={{
        borderColor: theme.gray[200],
      }}>
        {/* Header */}
        <div className="flex items-center gap-3 px-6 py-4 rounded-t-lg"
        style={{
          backgroundColor: theme.neutral.gray[100],
        }}>
          <BookOpen className="w-5 h-5" style={{ color: theme.primary.blue[600] }} />
          <h3 className="font-semibold text-lg"
          style={{
            color: theme.gray[800],
          }}>
            Explanation
          </h3>
        </div>
        
        {/* Content */}
        <div className="px-6 py-4">
          <HTMLContent htmlContent={explanation ?? ""} />
          
          {/* Topic Area - Integrated into explanation box */}
          <div className="flex justify-center mt-6">
            <div className="rounded-lg px-4 py-2 border inline-block"
            style={{
              borderColor: theme.gray[200],
            }}>
              <div className="flex items-center gap-3">
                <Tag className="w-4 h-4" style={{ color: theme.gray[500] }} />
                <span className="text-sm font-medium"
                style={{
                  color: theme.gray[600],
                }}>{topic}</span>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExplanationComponent;
